import { Address } from '@31third/common';

export class RebalancingAmountEntryDto {
  public tokenAddress: Address;
  public amount: string;
}
